var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.33398H2.66634C1.93301 1.33398 1.33301 1.93398 1.33301 2.66732V14.6673L3.99967 12.0007H13.333C14.0663 12.0007 14.6663 11.4007 14.6663 10.6673V2.66732C14.6663 1.93398 14.0663 1.33398 13.333 1.33398ZM13.333 10.6673H3.99967L2.66634 12.0007V2.66732H13.333V10.6673ZM4.66634 6.00065H5.99967V7.33398H4.66634V6.00065ZM7.33301 6.00065H8.66634V7.33398H7.33301V6.00065ZM9.99967 6.00065H11.333V7.33398H9.99967V6.00065Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSession);
export default __webpack_public_path__ + "static/media/UserSession.b45b9f7797ea4fb4515579a7450d51c4.svg";
export { ForwardRef as ReactComponent };